import { Component, Input, OnInit } from '@angular/core';
import { GitlabService } from '../../gitlab.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dashboard-merge-requests',
  templateUrl: './merge-requests.component.html',
  styleUrls: ['./merge-requests.component.css']
})
export class MergeRequestsComponent implements OnInit {

  @Input()
  gitlabInstanceName: string;

  projects: any[];
  mergeRequests: any[];

  constructor(private gitlabService: GitlabService) {
  }


  ngOnInit() {
    if (!this.gitlabInstanceName || this.gitlabInstanceName === '') {
      return;
    }

    this.gitlabService.getMergeRequests(this.gitlabInstanceName).subscribe(mrs => {

      let projectIds = new Set<number>();
      mrs.forEach(mr => projectIds.add(mr.project_id));

      forkJoin(Array.from(projectIds).map(projectId => this.gitlabService.getProject(this.gitlabInstanceName, projectId)))
        .subscribe(projects => {

          this.projects = projects.sort((a: any, b: any) => {
            let name_a = <string>a.name_with_namespace;
            let name_b = <string>b.name_with_namespace;
            return name_a.localeCompare(name_b);
          });

          this.mergeRequests = mrs;
        });
    });


  }

}
